import { Component, OnInit, OnDestroy, inject, effect, ChangeDetectionStrategy, computed, signal } from '@angular/core';
import { DashboardStateService } from '@app/services/dashboard-state.service';
import { DashboardApiService } from '@app/services/dashboard-api.service';
import { ViewRotationService } from '@app/services/view-rotation.service';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dashboard-shell',
    templateUrl: './dashboard-shell.component.html',
    styleUrl: './dashboard-shell.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DashboardShellComponent implements OnInit, OnDestroy {
  readonly stateService = inject(DashboardStateService);
  readonly apiService = inject(DashboardApiService);
  readonly rotationService = inject(ViewRotationService);

  readonly isOffline = computed(() => !this.stateService.lastData());
  readonly currentDateTime = signal(new Date());
  readonly isProduction = environment.production;

  private shiftChangeTimer: ReturnType<typeof setTimeout> | null = null;
  private timeUpdateInterval: ReturnType<typeof setInterval> | null = null;

  constructor() {
    effect(() => {
      if (this.stateService.isShiftChanging()) {
        this.shiftChangeTimer = setTimeout(() => {
          this.stateService.completeShiftChange();
        }, environment.dashboard.shiftOverlayDuration);
      }
    });
  }

  ngOnInit(): void {
    this.apiService.startPolling();
    this.rotationService.start();

    this.timeUpdateInterval = setInterval(() => {
      this.currentDateTime.set(new Date());
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.shiftChangeTimer) {
      clearTimeout(this.shiftChangeTimer);
    }
    if (this.timeUpdateInterval) {
      clearInterval(this.timeUpdateInterval);
    }
  }
}
